var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("date-picker", {
                attrs: {
                  type: "date",
                  format: "dd-MM-yyyy",
                  id: "fecha",
                  lang: "es"
                },
                model: {
                  value: _vm.form.fecha_abono,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fecha_abono", $$v)
                  },
                  expression: "form.fecha_abono"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha de abono *")]),
              _vm._v(" "),
              _vm.errores.fecha_abono
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.fecha_abono[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.money2,
                  id: "valor",
                  placeholder: "$ ##.##"
                },
                model: {
                  value: _vm.form.valor,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "valor", $$v)
                  },
                  expression: "form.valor"
                }
              },
              [
                _c("span", [_vm._v("Valor")]),
                _vm._v(" "),
                _vm.errores.valor
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.valor[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.form.tipo_abono !== "EF",
                expression: "form.tipo_abono !== 'EF'"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "bancoRetencion",
                  placeholder: "Escriba un banco o retención..."
                },
                model: {
                  value: _vm.form.banco_retencion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "banco_retencion", $$v)
                  },
                  expression: "form.banco_retencion"
                }
              },
              [
                _c("span", [_vm._v("Banco/Retención")]),
                _vm._v(" "),
                _vm.errores.banco_retencion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.banco_retencion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.form.tipo_abono === "EF",
                expression: "form.tipo_abono === 'EF'"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "input-field",
              {
                attrs: {
                  value: _vm.vuelto,
                  vMoney: "",
                  format: _vm.money2,
                  id: "vuelto",
                  placeholder: "$ ##.##",
                  readonly: ""
                }
              },
              [_c("span", [_vm._v("Vuelto")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select" }, [
          _c("div", { staticClass: "select-field" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.tipo_abono,
                    expression: "form.tipo_abono"
                  }
                ],
                attrs: { name: "tipo", id: "tipo" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "tipo_abono",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              _vm._l(_vm.tiposAbono, function(tipo) {
                return _c(
                  "option",
                  { key: tipo.id, domProps: { value: tipo.id } },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(tipo.nombre) +
                        "\n            "
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("label", { attrs: { for: "tipo" } }, [
              _vm._v("Tipo de abono *")
            ]),
            _vm._v(" "),
            _vm.errores.tipo_abono
              ? _c(
                  "span",
                  {
                    staticClass: "helper-text text-danger",
                    attrs: { slot: "helper" },
                    slot: "helper"
                  },
                  [_c("strong", [_vm._v(_vm._s(_vm.errores.tipo_abono[0]))])]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "textarea-field",
              {
                attrs: { placeholder: "...", id: "detalle" },
                model: {
                  value: _vm.form.obs_referencia,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "obs_referencia", $$v)
                  },
                  expression: "form.obs_referencia"
                }
              },
              [
                _c("span", [_vm._v("Observación / Referencia")]),
                _vm._v(" "),
                _vm.errores.obs_referencia
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.obs_referencia[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  value: _vm.saldoFinal,
                  vMoney: "",
                  format: _vm.money2,
                  id: "saldoAbono",
                  placeholder: "$ ##.##",
                  readonly: ""
                }
              },
              [_vm._v("\n          Saldo\n        ")]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: { click: _vm.cancelar }
        },
        [
          _c("i", { staticClass: "fa fa-close" }),
          _c("span", [_vm._v("Cerrar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.aceptar }
        },
        [
          _c("i", { staticClass: "fa fa-check" }),
          _c("span", [_vm._v("Aceptar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("h3", [_vm._v("Abono")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71dea036", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71dea036","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Abono.vue
// module id = 414
// module chunks = 0